import { App_User } from '@/data/user_info'
import Service from '@/service'
export default {
    data () {
        return {
            is_consultant: false,
            share_msg: '分享朋友圈',
            consultant: {},
            is_building_consultant: false
        }
    },
    methods: {
        async getUser (building_id) {
            const data = await App_User.get()
            this.is_consultant = data.is_consultant,
            this.share_msg = data.is_consultant ? '分享朋友圈' : '保存图片'
            if (data.is_consultant) {
                const res = await Service.getMyConsultant()
                this.consultant = res
                this.is_building_consultant = res.buildings
                    .map(building => building.id)
                    .indexOf(Number(building_id)) > -1
            }
        }
    }
}